import React from "react";
import DisplayWrapper from "../DisplayWrapper/DisplayWrapper";
import DefaultButton from "../Buttons/DefaultButton/DefaultButton";
import { Subscribe } from "unstated";
import StateContainer from "../../state/StateContainer";

import "./ToggleApartmentView.css";
import deviceHelper from "../../utils/helpers/deviceHelper";

function ToggleApartmentView(props) {
  const isMobile = deviceHelper.isMobileDevice();

  return (
    <div className="button_container2D3D">
      <div className="button_container">
        <span className="button_container2D3D-type">{props.unstated.state.button2DHeader || "2D"}</span>
        {props.unstated.state.button2DBody && 
			<span className="button_container2D3D-floor">{props.unstated.state.button2DBody}</span>
		}

        <DisplayWrapper displayParameter="apartmentViewButton">
          <DefaultButton
            buttonName="Apartment View"
            buttonClass={
              props.unstated.state.isApartment3DCanvasShown
                ? props.unstated.state.apartmentClickedInfo
                    .twoDimensionalPlanUrl === ""
                  ? "button2D opacity "
                  : "button2D opacity button_opacity"
                : "button2D no-opacity"
            }
            backgroundImage={props.unstated.state.button2DImageUrl || "/design/new-exports/2D_button.png"}

          />
        </DisplayWrapper>
      </div>
      <DisplayWrapper displayParameter="apartment3DViewButton">
        {props.unstated.state.apartmentClickedInfo.highResUrls.length > 0 ? (
          <div className="button_container d3">
            <DefaultButton
              buttonName="Apartment 3D View"
              buttonClass={
                props.unstated.state.isApartment3DCanvasShown
                  ? "button3D no-opacity"
                  : props.unstated.state.apartmentClickedInfo.highResUrls
                      .length > 0
                  ? "button3D opacity button_opacity"
                  : "button3D opacity"
              }
              backgroundImage={props.unstated.state.button3DImageUrl || "/design/new-exports/3D_button.png"}
            />

            {isMobile ? (
              <>
                {props.unstated.state.button3DBody && 
					<span className="button_container2D3D-floor">{props.unstated.state.button3DBody}</span>}
                <span className="button_container2D3D-type">{props.unstated.state.button3DHeader || "3D"}</span>
              </>
            ) : (
              <>
                <span className="button_container2D3D-type">{props.unstated.state.button3DHeader || "3D"}</span>
                {props.unstated.state.button3DBody && 
					<span className="button_container2D3D-floor">{props.unstated.state.button3DBody}</span>}
              </>
            )}
          </div>
        ) : null}
      </DisplayWrapper>
    </div>
  );
}

function ToggleApartmentViewWithUnstated(props) {
  return (
    <Subscribe to={[StateContainer]}>
      {(unstated) => <ToggleApartmentView {...props} unstated={unstated} />}
    </Subscribe>
  );
}

export default ToggleApartmentViewWithUnstated;
